<template>
    <div class="addMember">
      <el-form ref="form" label-width="80px">
        <el-form-item label="姓名">
          <el-input v-model="memberInfoCopy.trueName" type="text"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="memberInfoCopy.phone" type="number"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="memberInfoCopy.pasWord" type="text"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-cascader
              :options="regionData"
              v-model="area"
              filterable
              :props="{value:'label'}"
              placeholder="地址">
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="address" type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addMemberFn">确定</el-button>
          <el-button @click="cancle">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
import {editCustomer} from '@/api/api'
import bus from '@/bus'
import {testNull,testLength,testNumber} from '@/api/common'
import {regionData} from 'element-china-area-data'
export default {
  props:{
    memberInfo:{
      type:Object,
      required:false
    },
    id:{
      type:String,
      required:false
    }
  },
  name: 'HelloWorld',
  data () {
    return {
      memberInfoCopy:{
        trueName:'',
        phone:'',
      },
      area:[],
      address:'',
      regionData:[]
    }
  },
  mounted(){
    this.regionData=regionData
    this.memberInfoCopy= JSON.parse(JSON.stringify(this.memberInfo))
    this.address=this.memberInfo.address.split(',').splice(3,1)
    this.area=this.memberInfo.address.split(',').splice(0,3)
  },
  methods:{
    cancle(){
       bus.$emit('closeEditMember')
    },
    addMemberFn(){
      const {id,trueName,phone,pasWord} = this.memberInfoCopy
      let test=true
      test=testNull(this,trueName,'姓名')
      if(!test){return false}
      test=testNull(this,phone,'电话')
      if(!test){return false}
      test=testNull(this,pasWord,'密码')
      if(!test){return false}
      test=testNull(this,this.address,'详细地址')
      if(!test){return false}
      test=testNull(this,this.area,'城市')
      if(!test){return false}
      test=testLength(this,trueName,10,'姓名')
      if(!test){return false}
      let rule=/^1\d{10}$/
      test=rule.test(phone)
      if(!test){
        this.$message({
          message:'电话格式不正确',
          type: 'warning'
        })
        return false
        }
      let data=JSON.stringify({
          id,
          trueName,
          phone,
          pasWord,
          'address':this.area.join(',')+','+this.address
        })
        editCustomer(data).then(res=>{
           this.fedeback(res)
        })
      },
    fedeback(res){
      if(res.data.state==200&&res.data.data==1){
        this.form={}
        bus.$emit('closeEditMember')
        this.$message({
           message: '操作成功',
           type: 'success'
        })
      }else{
        this.$message({
           message:res.data.data,
           type: 'warning'
        })
      }
    },
  },
  beforeRouteEnter(to,from,next) {
    var that=this
    var manager=localStorage.getItem('manager')
    if(manager=='M'){
      next()
    }else{
       alert('您没有访问权限')
       next('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .addCoctor {margin-left:20px;}
  .addCoctor li {height:50px;}
  .addDoctorItem {width:290px;height:30px;line-height: 30px;float: left;}
  .addDoctorItem span {width:120px;font-size:14px;text-align:right;float: left;}
  .addDoctorItem em {font-size:12px;margin-left:10px;}
  .addDoctorItem a {color:#357af1;}
  .addDoctorItem input[type=text] {color:#555;width:150px;height:30px;margin-left:5px;padding-left:10px;border:0;border-radius:4px;border:#ddd 1px solid;float: left;}
  .addDoctorItem input[type=number] {color:#555;width:150px;height:30px;margin-left:5px;padding-left:10px;border:0;border-radius:4px;border:#ddd 1px solid;float: left;}
  .addDoctorItem textarea {color:#555;width:300px;height:80px;line-height:22px;margin-left:5px;padding-left:10px;padding-top:10px;resize:none;border:#ddd 1px solid;border-radius:4px;}
  .addDoctorItem label {margin-right:30px;}
  .addDoctorItem input[type=radio] {margin-right:5px;position: relative;top:1px;}
  .addMember {width:350px;margin-left:40px;}
</style>



// WEBPACK FOOTER //
// src/components/EditCustomer.vue